export const SHARED_MEDIA_PARENT_OPPORTUNITY = 'opportunity';
export const SHARED_MEDIA_PARENT_BOOKING = 'booking';

// resolveSharedMediaParent decides which entity a Vietnam sale's documents hang off: the CRM
// opportunity behind the booking (CPI-1249 A20), or the booking itself when there is none (A21).
// parentID comes back empty when neither id is known - callers MUST then refuse to call
// GET /shared_medias/, because a blank parent_id returns every active row in the database.
export const resolveSharedMediaParent = (booking, bookingID) => {
  const leadOpportunityID = booking && booking.leadOpportunityID;

  if (leadOpportunityID) {
    return {
      parentType: SHARED_MEDIA_PARENT_OPPORTUNITY,
      parentID: leadOpportunityID,
    };
  }

  return {
    parentType: SHARED_MEDIA_PARENT_BOOKING,
    parentID: bookingID || (booking && booking.id) || '',
  };
};

export default resolveSharedMediaParent;



// WEBPACK FOOTER //
// ./src/utils/sharedMedia.js